import { equal } from 'assert';
import { get } from 'http';
import { formatDate } from 'utils/constants/functions';

export const VARIABLES_PAYMENT_SUMMARY = {
  getListPaymentSummary: (params: any) => {
    const {
      id,
      plantId,
      statusId,
      customerId,
      fromDateToDate,
      page,
      page_size,
      teamSaleId,
      managerId,
    } = params;
    // console.log('params', params);
    return {
      skip: page_size * (page - 1),
      take: page_size,
      input: {
        ...(id && { id }),
        ...(plantId && { plantId }),
        ...(statusId !== undefined && statusId != null && { statusId }),
        ...(customerId && { customerId }),
        ...(teamSaleId && { teamSaleId }),
        ...(fromDateToDate && {
          fromDate: fromDateToDate[0].format('YYYY-MM-DD 00:00:00'),
          toDate: fromDateToDate[1].format('YYYY-MM-DD 23:59:59'),
        }),
        ...(managerId && { managerId }),
      },
    };
  },

  getCustomerCheckInByPlant: (params: any) => {
    const { plantId, searchKey, pageSize } = params;
    return {
      take: pageSize,
      skip: 0,
      input: {
        ...(plantId && { plantId }),
        ...(searchKey && { searchKey }),
      },
    };
  },

  getOrderBillPaymentList: (params: any) => {
    const { id } = params;
    return {
      id: id || '',
    };
  },
};
